import { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TELEGRAM_USERNAME = 'cloakitaurasupport';

export default function TelegramSupport() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const openTelegram = () => {
    window.open(`https://t.me/${TELEGRAM_USERNAME}`, '_blank');
  };

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          className="fixed bottom-6 right-6 z-50 w-16 h-16 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 group"
          style={{
            background: 'linear-gradient(135deg, #0088cc 0%, #229ED9 100%)',
            boxShadow: '0 8px 32px rgba(0, 136, 204, 0.4), 0 0 0 0 rgba(0, 136, 204, 0.4)',
            animation: 'pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
          }}
        >
          <div className="relative w-full h-full flex items-center justify-center">
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="#fff">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.692-1.653-1.123-2.678-1.799-1.185-.781-.417-1.21.258-1.911.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.329-.913.489-1.302.481-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.324-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.141.121.099.155.232.171.326.016.094.037.308.02.475z"/>
            </svg>
            <div className="absolute inset-0 rounded-full" style={{
              background: 'linear-gradient(135deg, rgba(0, 136, 204, 0.2) 0%, rgba(34, 158, 217, 0.2) 100%)',
              animation: 'ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite'
            }} />
          </div>
        </button>
      )}

      {/* Chat Box */}
      {isOpen && (
        <div 
          className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${
            isMinimized ? 'w-80 h-16' : 'w-96 h-[500px]'
          }`}
          style={{
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(0, 136, 204, 0.3)'
          }}
        >
          {/* Header */}
          <div 
            className="rounded-t-lg p-4 flex items-center justify-between cursor-pointer"
            style={{
              background: 'linear-gradient(135deg, #0088cc 0%, #229ED9 100%)'
            }}
            onClick={() => setIsMinimized(!isMinimized)}
          >
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="#fff">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.692-1.653-1.123-2.678-1.799-1.185-.781-.417-1.21.258-1.911.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.329-.913.489-1.302.481-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.324-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.141.121.099.155.232.171.326.016.094.037.308.02.475z"/>
                </svg>
              </div>
              <div>
                <div className="font-bold text-white text-sm">Cloak It Aura Support</div>
                <div className="text-xs text-white/80 flex items-center gap-1">
                  <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
                  Online
                </div>
              </div>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
              className="w-8 h-8 rounded-full hover:bg-white/20 flex items-center justify-center transition-colors"
            >
              <X className="w-5 h-5 text-white" />
            </button>
          </div>

          {/* Chat Content */}
          {!isMinimized && (
            <div className="bg-[#0a0a0a] h-[calc(100%-64px)] rounded-b-lg border-x border-b" style={{borderColor: 'rgba(0, 136, 204, 0.3)'}}>
              <div className="h-full flex flex-col">
                {/* Messages Area */}
                <div className="flex-1 p-4 overflow-y-auto space-y-4">
                  {/* Support Message */}
                  <div className="flex gap-3">
                    <div className="w-8 h-8 rounded-full flex-shrink-0" style={{background: 'linear-gradient(135deg, #0088cc 0%, #229ED9 100%)'}}>
                      <svg className="w-8 h-8 p-1.5" viewBox="0 0 24 24" fill="#fff">
                        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.5 1.201-.82 1.23-.697.064-1.226-.461-1.901-.903-1.056-.692-1.653-1.123-2.678-1.799-1.185-.781-.417-1.21.258-1.911.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.329-.913.489-1.302.481-.428-.008-1.252-.241-1.865-.44-.752-.244-1.349-.374-1.297-.789.027-.216.324-.437.893-.663 3.498-1.524 5.831-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635.099-.002.321.023.465.141.121.099.155.232.171.326.016.094.037.308.02.475z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="bg-[#1a1a1a] rounded-lg rounded-tl-none p-3 max-w-[260px]" style={{border: '1px solid rgba(0, 136, 204, 0.2)'}}>
                        <p className="text-sm text-foreground">👋 Hello! Welcome to Cloak It Aura Support.</p>
                        <p className="text-sm text-foreground mt-2">Need help with:</p>
                        <ul className="text-sm text-muted-foreground mt-2 space-y-1">
                          <li>• Campaign setup</li>
                          <li>• Bot detection</li>
                          <li>• PHP integration</li>
                          <li>• Subscription plans</li>
                        </ul>
                        <p className="text-sm text-foreground mt-2">Click below to chat with us on Telegram!</p>
                      </div>
                      <div className="text-xs text-muted-foreground mt-1">Just now</div>
                    </div>
                  </div>

                  {/* Info Card */}
                  <div className="bg-[#1a1a1a] rounded-lg p-4" style={{border: '1px solid rgba(0, 136, 204, 0.2)'}}>
                    <div className="flex items-center gap-2 mb-2">
                      <MessageCircle className="w-4 h-4" style={{color: '#229ED9'}} />
                      <span className="text-sm font-semibold" style={{color: '#229ED9'}}>Quick Support</span>
                    </div>
                    <p className="text-xs text-muted-foreground mb-3">
                      Get instant help via Telegram. Our team responds within minutes!
                    </p>
                    <div className="space-y-2 text-xs text-muted-foreground">
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full" style={{background: '#229ED9'}} />
                        <span>Response time: ~5 minutes</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full" style={{background: '#229ED9'}} />
                        <span>Available: 24/7</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <div className="w-1.5 h-1.5 rounded-full" style={{background: '#229ED9'}} />
                        <span>Language: English</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action Button */}
                <div className="p-4 border-t" style={{borderColor: 'rgba(0, 136, 204, 0.2)'}}>
                  <Button
                    onClick={openTelegram}
                    className="w-full rounded-lg text-base py-6 flex items-center justify-center gap-2 text-white font-semibold"
                    style={{
                      background: 'linear-gradient(135deg, #0088cc 0%, #229ED9 100%)',
                    }}
                  >
                    <Send className="w-5 h-5" />
                    Open Telegram Chat
                  </Button>
                  <p className="text-center text-xs text-muted-foreground mt-2">
                    @{TELEGRAM_USERNAME}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <style jsx global>{`
        @keyframes pulse-ring {
          0%, 100% {
            box-shadow: 0 8px 32px rgba(0, 136, 204, 0.4), 0 0 0 0 rgba(0, 136, 204, 0.4);
          }
          50% {
            box-shadow: 0 8px 32px rgba(0, 136, 204, 0.4), 0 0 0 20px rgba(0, 136, 204, 0);
          }
        }
        
        @keyframes ping {
          75%, 100% {
            transform: scale(2);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
}
